import merge from "lodash.merge";
import { createTheme } from "@material-ui/core/styles";
import { theme as immatTheme } from "./immatTheme";
import { theme as proTheme } from "./proTheme";

export const theme = merge({}, immatTheme, proTheme, {});

export default createTheme(theme);
